export const sizes = {
	h35: 35,
	w250: 250,
	w300: 300,
	w500: 500,
	w650: 650,
	w750: 750,
};

/** Same pattern as Run Rate default ([1]): list index matches enum id (Exact Value AI FC = 4). */
export const DEFAULT_INITIAL_FORECAST_LIST_INDEX = 4;

export function getDefaultInitialForecastName(defaultInitialForecastList = []) {
	return (
		defaultInitialForecastList?.[DEFAULT_INITIAL_FORECAST_LIST_INDEX]?.name ??
		defaultInitialForecastList?.[0]?.name ??
		""
	);
}

export function getSkuBreakdownOptions(selectedDSs = []) {
	return selectedDSs.filter(
		(source) => source !== "Forecast" && source !== "SIT"
	);
}

export function getDefaultSkuBreakdown(selectedDSs = []) {
	const options = getSkuBreakdownOptions(selectedDSs);
	return options.length > 0 ? options[0] : "";
}
